import React, { Component } from "react"
import {Switch, Route, NavLink} from "react-router-dom"

import {DarePage} from './dare'
import {UsersPage} from './user'
import {TermsPage} from './terms'
import MenuItem from "./components/MenuItem"
import { auth, db } from '../../service';

export class Admin extends Component {

    constructor(props) {
        super(props)
        this.state = {
            togle_islaod: false,
            user_count: 1
        }
    }

    componentDidMount(){
        db.collection('users').get().then(snap => {
            this.setState({user_count: snap.size})
         });
    }

    render() {
        return (
            <div className={this.state.togle_islaod ? "toggled" : ""} id="wrapper" >
                <header class="topbar-nav">
                    <nav class="navbar navbar-expand fixed-top bg-white">
                    <ul class="navbar-nav mr-auto align-items-center">
                        <li class="nav-item">
                            <a class="nav-link toggle-menu" onClick={() =>  this.setState(prevState => ({togle_islaod: !prevState.togle_islaod}))}>
                        <i class="icon-menu menu-icon"></i>
                        </a>
                        </li>
                    </ul>
                    </nav>
                </header>
                <div id="sidebar-wrapper" data-simplebar="" data-simplebar-auto-hide="true">
                    <div className="brand-logo">
                        <img src="/static/media/mangaa_logo.8851ea56.png" className="logo-icon" alt="logo icon"></img>
                        <h5 className="logo-text">Мангаа</h5>
                    </div>
                    <ul className="sidebar-menu do-nicescrol">
                        <MenuItem icon="gp-text-info fa fa-question" url="/mangarmangaagiinadmin/dare/dare1" text="Dare"></MenuItem>
                        <MenuItem icon="gp-text-info fa fa-users" count={this.state.user_count} url="/mangarmangaagiinadmin/users" text="Хэрэглэгчид"></MenuItem>
                        <MenuItem icon="gp-text-info fa fa-info" url="/mangarmangaagiinadmin/terms" text="Terms"></MenuItem>
                    </ul>
                </div>
                <div className="content-wrapper">
                    <Switch>
                        <Route path={"/mangarmangaagiinadmin/dare"} component={DarePage}/>
                        <Route path={"/mangarmangaagiinadmin/users"} component={UsersPage}/>
                        <Route path={"/mangarmangaagiinadmin/terms"} component={TermsPage}/>
                    </Switch>
                </div>
            </div>
        )

    }

}
